/** @format */

import { useRouter } from "next/router";
import { Layout } from "../../components/common/Layout";
import NotFound from "../../components/NotFound/NotFound";
import SellerLanding from "../../components/SellerLanding/SellerLanding";
import Spinner from "../../components/Spinner/Spinner";
import { v4 as uuidv4 } from "uuid";

export default function SellerLandingPage({ data = {} }) {
  const router = useRouter();
  const { sellerDetails = {} } = data || {};
  const categories = sellerDetails?.categoryDescs
    ? sellerDetails.categoryDescs.join(", ")
    : "home decor & fashion, home and lifestyle";
  // const adjCategories =
  //   categories.length > 23 ? `${categories.substring(0, 20)}...` : categories;
  const sellerName = sellerDetails?.brandName ? sellerDetails.brandName : "";
  // const adjSellerName =
  //   sellerName.length > 23 ? `${sellerName.substring(0, 20)}...` : sellerName;
  const meta = {
    title: `Source wholesale home decor & fashion wholesale | Verified suppliers | Qalara`,
    description:
      "Shop wholesale clothing, home & lifestyle categories from verified wholesale supplier in India & South Asia",
    keywords: `${sellerName}, Global sourcing, ${categories}, wholesale, exports, sustainable, wholesale buying India, global sources, wholesale products, sourcing wholesale, manufacturer in India`,
    url: "/seller-profile/" + data?.sellerId + "/",
  };

  if (data?.error?.status) {
    return (
      <>
        <NotFound />
      </>
    );
  }

  if (router.isFallback) {
    return <Spinner />;
  }
  return (
    <Layout meta={meta}>
      <SellerLanding data={data} />
    </Layout>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}

export const getStaticProps = async ({ params: { sellerId = "" } = {} }) => {
  let res = {};
  const error = { status: false };

  try {
    // https://api-dev.qalara.com:1190/sellers/SL10107
    const responseSD = await fetch(
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
        "/profile/v1/sellers" +
        `/${sellerId}` + "/profile",
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
          'trace-id' : uuidv4()
        },
      }
    );
    res["sellerDetails"] = await responseSD.json();

    let id = await res?.sellerDetails?.id?.replace("HOME::", "");
    // let id = sellerId;

    const response_about = await fetch(
      process.env.NEXT_PUBLIC_REACT_APP_API_PROFILE_URL +
        "/seller-home/ABOUT::" +
        id +
        "/about",
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
        },
      }
    );
    const res_about = await response_about.json();
    res["about"] = res_about.length > 0 ? res_about[0]["htmlContent"] : "";

    const response_category_product_range = await fetch(
      process.env.NEXT_PUBLIC_REACT_APP_API_PROFILE_URL +
        "/seller-home/" +
        id +
        "/category-product-range",
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
        },
      }
    );
    res["category_product_range"] =
      await response_category_product_range.json();
  } catch (error) {
    error["status"] = true;
  }

  return {
    props: {
      data: {
        sellerDetails: res.sellerDetails || null,
        about: res.about || null,
        category_product_range: res.category_product_range || null,
        error: error,
        sellerId: sellerId,
      },
    },
    revalidate: 1000,
  };
};
